export default "__VITE_ASSET__CsYRYdfB__"